import { IBankConnection } from '@/types'
import { BANK_CONNECTION_STATUS } from '@/utils/constants'
import { isInactiveConnectionStatus, normaliseConnectionStatus } from '@/utils/connectionStatus'
import { mainConnection } from './mainConnection'

const statusOf = (connection: IBankConnection) => normaliseConnectionStatus(connection.status)

// Pending is an intermediate state on its way to active, so a pending primary can be the main one.
const MAIN_STATUSES: string[] = [
  BANK_CONNECTION_STATUS.ACTIVE,
  BANK_CONNECTION_STATUS.NEAR_EXPIRY,
  BANK_CONNECTION_STATUS.PENDING,
]

export interface IConnectionGroups {
  main?: IBankConnection
  other: IBankConnection[]
  inactive: IBankConnection[]
}

// Prototype grouping for the grouped view. The main connection is a primary that is live or
// pending, picked as the list view picks one. A connection that can no longer sync is inactive, primary or
// not; everything else is another connection. Each group keeps the order the service sent.
export const groupConnections = (connections: IBankConnection[]): IConnectionGroups => {
  const inactive = connections.filter(connection => isInactiveConnectionStatus(connection.status))
  const main = mainConnection(
    connections.filter(connection => MAIN_STATUSES.includes(statusOf(connection)))
  )
  const other = connections.filter(
    connection => connection !== main && !inactive.includes(connection)
  )

  return { main, other, inactive }
}
